import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MediaType, User } from '../../models';
import { Action, ActionLabel, Page } from '../intro-flow/intro-flow-page.model';
import { AutoSub, AutoSubOnDestroy, UserService } from '../../providers';
import { TutorialAnimation } from '../tutorial-animation/tutorial-animation.component';

@AutoSubOnDestroy()
@Component({
    selector: 'intro-flow-page',
    templateUrl: './intro-flow-page.component.html',
    styleUrls: ['./intro-flow-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IntroFlowPageComponent implements OnInit {

    @ViewChild('videoPlayer') video: ElementRef<HTMLVideoElement>;
    @ViewChild('tutorialAnimation') tutorialAnimation: TutorialAnimation;

    @Input() page: Page = null;
    @Input() disableButtons: boolean = false;
    @Input() rollBanners: boolean = false;

    @Output() actionChange = new EventEmitter<Action>();

    public user: User = null;

    // Expose to view
    public MediaType = MediaType;
    public Action = Action;
    public ActionLabel = ActionLabel;

    constructor(private userService: UserService) { }

    ngOnInit(): void {
        // Watch user
        AutoSub(this).reg['userSub'] = this.userService.watchCurrentUser().subscribe(async (user) => {
            this.user = user;
        });
    }

    public emitAction(action: Action) {
        this.actionChange.emit(action);
        if(this.page.animationPage) this.tutorialAnimation.goToNextState();
    }
}
